
import React from "react";

import BsyDashChartBase from '../BsyDashChartBase'
// import { BsyDashUtils } from '../../../utils/DashUtils';
// import {echarts} from '../../../plugins/echarts.js';
import BsySLoading from '../../BsySLoading';

import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashMultiAxesChart extends BsyDashChartBase {


    constructor(props) {
        super(props)
        this.state = {
            ...this.state
        }
    }

    _initChartOption = (e, i, n, r) => {

        let _this = this
            , opt = _this.props;
        if (e) {
            i = [React.language("report.chart.legend", {
                val: "1"
            }), React.language("report.chart.legend", {
                val: "2"
            })]
            n = [React.language("report.chart.category", {
                val: "1"
            }), React.language("report.chart.category", {
                val: "2"
            }), React.language("report.chart.category", {
                val: "3"
            }), React.language("report.chart.category", {
                val: "4"
            }), React.language("report.chart.category", {
                val: "5"
            })]
            r = [[1, 3, 8, 7, 9], [8, 6, 4, 2, 7]]
        }

        if (!r || r.length == 0) {
            this.setState({
                dataEmpty:true,
            })
            return;
        }
        this.setState({
            dataEmpty:false,
        },()=>{
            let option = {};
            let option1 = this._renderOptions(option, i, n, r);
            if (this.myCharts) {
                this.myCharts.dispose();
                this.echartsRef.current.innerHTML = '';
            }
            this.myCharts = window.echarts.init(this.echartsRef.current);
            if (option1.onFinished) {
                this.myCharts.on('finished', function () {
                    option1.onFinished && option1.onFinished(_this.myCharts);
                });
            }
            this.myCharts.on('click', function (params) {
                let i = [];
                if (_this.yGroups && _this.yGroups[0]) {
                    let n = params.seriesName || params.name;
                    if(_this.nameMap[n]) {
                        n = _this.nameMap[n];
                    }
                    let r = _this._dealLinkData(_this.yGroups[0], n);
                    r.field = _this.yGroups[0].name
                    i.push(r)
                }
                if (_this.xGroups && _this.xGroups[0]) {
                    let a = params.category || params.name
                        , o = _this.name || _this.nameMap[a] || a
                        , s = _this._dealLinkData(_this.xGroups[0], o);
                    s.field = _this.xGroups[0].name
                    i.push(s)
                }
                if (_this.state.valueFields[0]) {
                    _this.linkParam = _this._getLinkFilterParams(i)
                    BsyUtils.applyFunc(_this, opt.onItemClick, [_this.linkParam], !1)
                }
            });
            this.myCharts.setOption(option1)
        })
 
    }
    _addThresholdLine = () => {
        let t = this
            , e = this.props
            , i = []
            , n = 0;

        let markLine = [{
            silent: true,
            symbol: "none",
            max: null,
            min: null,

            data: [],
        }, {
            silent: true,
            symbol: "none",
            max: null,
            min: null,

            data: [],
        }];

        BsyUtils.forEach(e.guideline, (n, r) => {
            let a, o, s, h = "", l = "";
            if ("dynamic" === r.type) {
                let c = t.guidelineVal[r.field];
                s = c && c[r.aggregate]
                BsyUtils.forEach(e.valueFields, function (t, e) {
                    if (e.tag === r.field) {
                        a = "right" === e.metricType ? 1 : 0
                        o = t;
                        r.position = e.metricType;
                        return !1
                    }

                })
                l = t._formatValue(s, o || 0)
            } else
                s = r.value;

            if ("right" === r.position) {
                a = 1
                o = t._getFirstValidFormatIndex(t.rightFields)
                l = t._formatYaxisValue(s, o, t.rightFields)
            } else {
                a = 0
                o = t._getFirstValidFormatIndex(t.leftFields)
                l = t._formatYaxisValue(s, o, t.leftFields)
            }


            // "right" === r.position ? (a = 1,
            //     o = t._getFirstValidFormatIndex(t.rightFields),
            //     l = t._formatYaxisValue(s, o, t.rightFields)) : (a = 0,
            //         o = t._getFirstValidFormatIndex(t.leftFields),
            //         l = t._formatYaxisValue(s, o, t.leftFields));


            if (markLine[a].max === null) {
                markLine[a].max = s;
            }
            if (markLine[a].min === null) {
                markLine[a].min = s;
            }

            r.is_label_visible && (h = r.label)
            r.is_value_visible && (h += BsyUtils.isEmpty(h) ? l : "：" + l)
            i[a] || (i[a] = [])
            s > markLine[a].max && (markLine[a].max = s)
            s < markLine[a].min && (markLine[a].min = s)

            markLine[a].data.push({
                yAxis: s,
                label: {
                    position: a ? "insideEndTop" : "insideStartTop",//"insideStartTop",
                    color: r.color,
                    formatter: h,
                    fontSize: 10
                },
                lineStyle: {
                    color: r.color,
                    type: "dashed"
                }
            })
        })
        BsyUtils.forEach(e.thresholds, (r, a) => {
            if (a.enable) {
                let o = a.cond
                    , s = o.value && o.value[0];

                if (markLine[a].max === null) {
                    markLine[a].max = s;
                }
                if (markLine[a].min === null) {
                    markLine[a].min = s;
                }
                BsyUtils.forEach(t.metrics, function (t, e) {
                    if (e.fieldName === o.field)
                        return n = "left" === e.metricType ? 0 : 1,
                            !1
                })
                i[n] || (i[n] = []);
                let h;
                BsyUtils.forEach(e.valueFields, function (t, e) {
                    if (o.field === e.tag)
                        return h = t,
                            !1
                })
                s > markLine[a].max && (markLine[a].max = s)
                s < markLine[a].min && (markLine[a].min = s)
                markLine[a].data.push({
                    yAxis: s,
                    label: {
                        position: a ? "insideEndTop" : "insideStartTop",//"insideStartTop",
                        color: e.thresholdColor,
                        formatter: t._formatValue(s, h),
                        fontSize: 10
                    },
                    lineStyle: {
                        color: e.thresholdColor,
                        type: "dashed"
                    }
                })
            }
        });


        //最大值最小值一样会导致辅助线不显示
        if (markLine[0].min == markLine[0].max) {
            if (markLine[0].max == 0) {
                markLine[0].max = 0.1;
            }
            else
                markLine[0].max = markLine[0].max + (Math.abs(markLine[0].max / 10) > 10 ? 10 : Math.abs(markLine[0].max / 10))
        }

        if (markLine[1].min == markLine[1].max) {
            if (markLine[1].max == 0) {
                markLine[1].max = 0.1;
            }
            else
                markLine[1].max = markLine[1].max + (Math.abs(markLine[1].max / 10) > 10 ? 10 : Math.abs(markLine[1].max / 10))
        }
        return markLine;

    }

    _formatYaxisValue = (t, e, i) => {
        BsyUtils.isObjectEmpty(i) || 1 !== i.length || (e = 0);
        let n = i[e] && i[e].format
            , r = BsyUtils.fixDecimalPrecision(t);
        return BsyUtils.num2Str(r, n)
    }
    _getFieldsByType = (t) => {
        let e = this.props
            , i = [];
        BsyUtils.forEach(e.valueFields, function (e, n) {
            n.metricType === t && i.push(n)
        })
        return i
    }
    _addCustomChartOptions = () => {
        let t = this; let _ = this;

        this.leftFields = this._getFieldsByType("left")
        this.rightFields = this._getFieldsByType("right")
        // this.chartOptions.yAxis = [{
        //     enableMinorTick: !1,
        //     gridLineColor: "var(--bsy-base-bgcolor-f3)",
        //     minorTickColor: "#d0d0d0",
        //     tickColor: "#d0d0d0",
        //     showArrow: !1,
        //     lineColor: "#d0d0d0",
        //     plotLines: [],
        //     type: "value",
        //     lineWidth: 1,
        //     splitLine:{
        //         "show": true,
        //         lineStyle:{
        //             color:"#d0d0d0"
        //         }
        //     },
        //     showLabel: !0,
        //     gridLineWidth: 1,
        //     enableTick: !1,
        //     labelStyle: {
        //         fontFamily: "Verdana",
        //         color: "#6f6f6f",
        //         fontSize: "12px"
        //     },
        //     formatter: function(e) {
        //         let i = t._getFirstValidFormatIndex(t.leftFields);
        //         return t._formatYaxisValue(e, i, t.leftFields)
        //     },
        //     plotBands: [],
        //     position: "left",
        //     labelRotation: 0,
        //     reversed: !1
        // }, {
        //     enableMinorTick: !1,
        //     gridLineColor: "var(--bsy-base-bgcolor-f3)",
        //     minorTickColor: "#d0d0d0",
        //     tickColor: "#d0d0d0",
        //     showArrow: !1,
        //     splitLine:{
        //         "show": true,
        //         lineStyle:{
        //             color:"#F0F0F0"
        //         }
        //     },
        //     lineColor: "#d0d0d0",
        //     plotLines: [],
        //     type: "value",
        //     lineWidth: 1,
        //     showLabel: !0,
        //     gridLineWidth: 0,
        //     enableTick: !1,
        //     labelStyle: {
        //         fontFamily: "Verdana",
        //         color: "#6f6f6f",
        //         fontSize: "12px"
        //     },
        //     formatter: function(e) {
        //         let i = t._getFirstValidFormatIndex(t.rightFields);
        //         return t._formatYaxisValue(e, i, t.rightFields)
        //     },
        //     plotBands: [],
        //     position: "right",
        //     labelRotation: 0,
        //     reversed: !1
        // }]
    }

    _checkInterval = () => {
        let h = this; let _ = this;
        let sliptNumber = 100;
        let indMax = 0;
        let indMin = 0;
        let markLine = _._addThresholdLine()
        let leftA = false;
        let rightA = false;
        BsyUtils.forEach(_.metrics, function (a1, b1) {
            if (b1.metricType == "left") {
                leftA = true;
            }
            else if (b1.metricType == "right") {
                rightA = true;
            }
        });

        if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {

            let muxtype = "left";

            BsyUtils.forEach(h.chartUtils.data, function (a1, b1) {

                if (muxtype === h.metrics[a1].metricType) {
                    if (_.yAxes[0].chart_type == 'area_chart') {
                        let tmpmax = Math.max.apply(null, b1);
                        indMax += tmpmax;
                        let tmpmin = Math.min.apply(null, b1);
                        indMin += tmpmin;
                    }
                    else {
                        let tmpmax = Math.max.apply(null, b1);
                        if (tmpmax > indMax)
                            indMax = tmpmax;
                        let tmpmin = Math.min.apply(null, b1);
                        if (tmpmin < indMin)
                            indMin = tmpmin;
                    }

                }
            })

            if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null) {
                indMax = _.yAxes[0].max;

                if (markLine[0] && !BsyUtils.isObjectEmpty(markLine[0].data)) {
                    let markLineValue = _.niceTicks(markLine[0].min, markLine[0].max)
                    if (markLine[0].max > indMax) {
                        indMax = markLineValue[1];
                    }
                }
            }
            else {
                if (markLine[0] && !BsyUtils.isObjectEmpty(markLine[0].data)) {
                    let markLineValue = _.niceTicks(markLine[0].min, markLine[0].max)
                    if (markLine[0].max > indMax) {
                        indMax = markLineValue[1];
                    }
                }
            }
            if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null) {
                indMin = _.yAxes[0].min;
                if (markLine[0] && !BsyUtils.isObjectEmpty(markLine[0].data)) {
                    let markLineValue = _.niceTicks(markLine[0].min, markLine[0].max)
                    if (markLine[0].min < indMin) {
                        indMin = markLineValue[0];
                    }
                }
            }
            else {
                if (markLine[0] && !BsyUtils.isObjectEmpty(markLine[0].data)) {
                    let markLineValue = _.niceTicks(markLine[0].min, markLine[0].max)
                    if (markLine[0].min < indMin) {
                        indMin = markLineValue[0];
                    }
                }
            }

            if (indMax < 0 && indMin < 0) {
                let d = [Math.abs(indMin), Math.abs(indMax)];

                let min = Math.min.apply(null, d);
                let max = Math.max.apply(null, d);

                indMax = max
                indMin = min;
            }

            let nn = (indMax - indMin) / sliptNumber;

            if (_.yAxes[0].hasOwnProperty("maxInterval") && _.yAxes[0].maxInterval !== null) {

                if (_.yAxes[0].maxInterval < nn) {
                    _.yAxes[0].maxInterval = undefined;
                }
            }


            if (_.yAxes.length > 1) {
                indMax = 0;
                indMin = 0;
                muxtype = "right";
                BsyUtils.forEach(h.chartUtils.data, function (a1, b1) {
                    if (muxtype === h.metrics[a1].metricType) {
                        if (_.yAxes[1].chart_type == 'area_chart') {
                            let tmpmax = Math.max.apply(null, b1);
                            indMax += tmpmax;
                            let tmpmin = Math.min.apply(null, b1);
                            indMin += tmpmin;
                        }
                        else {
                            let tmpmax = Math.max.apply(null, b1);
                            if (tmpmax > indMax)
                                indMax = tmpmax;
                            let tmpmin = Math.min.apply(null, b1);
                            if (tmpmin < indMin)
                                indMin = tmpmin;
                        }

                    }
                })

                if (_.yAxes[1].hasOwnProperty("max") && _.yAxes[1].max !== null) {
                    indMax = _.yAxes[1].max;

                    if (markLine[1] && !BsyUtils.isObjectEmpty(markLine[1].data)) {
                        let markLineValue = _.niceTicks(markLine[1].min, markLine[1].max)
                        if (markLine[1].max > indMax) {
                            indMax = markLineValue[1];
                        }
                    }
                }
                else {
                    if (markLine[1] && !BsyUtils.isObjectEmpty(markLine[1].data)) {
                        let markLineValue = _.niceTicks(markLine[1].min, markLine[1].max)
                        if (markLine[1].max > indMax) {
                            indMax = markLineValue[1];
                        }
                    }
                }
                if (_.yAxes[1].hasOwnProperty("min") && _.yAxes[1].min !== null) {
                    indMin = _.yAxes[1].min;
                    if (markLine[1] && !BsyUtils.isObjectEmpty(markLine[1].data)) {
                        let markLineValue = _.niceTicks(markLine[1].min, markLine[1].max)
                        if (markLine[1].min < indMin) {
                            indMin = markLineValue[0];
                        }
                    }
                }
                else {
                    if (markLine[1] && !BsyUtils.isObjectEmpty(markLine[1].data)) {
                        let markLineValue = _.niceTicks(markLine[1].min, markLine[1].max)
                        if (markLine[1].min < indMin) {
                            indMin = markLineValue[0];
                        }
                    }
                }

                if (indMax < 0 && indMin < 0) {
                    let d = [Math.abs(indMin), Math.abs(indMax)];

                    let min = Math.min.apply(null, d);
                    let max = Math.max.apply(null, d);

                    indMax = max
                    indMin = min;
                }
                let nn = (indMax - indMin) / sliptNumber;

                if (_.yAxes[1].hasOwnProperty("maxInterval") && _.yAxes[1].maxInterval !== null) {
                    if (_.yAxes[1].maxInterval < nn) {
                        _.yAxes[1].maxInterval = undefined;
                    }
                }
            }
        }
    }

    _getSeriesType = (t) => {
        let e = "";
        switch (t) {
            case "column_chart":
            case "stacked_column_chart":
                e = "bar";
                break;
            case "line_chart":
                e = "line";
                break;
            case "area_chart":
                e = "line"
                break;
            default: {
                break;
            }
        }
        return e
    }

    
}